import { DSCBComponent, DSResource } from 'shared-definitions/types'
import { nullableString } from 'shared-code/conversion'
import { ApiComponent, ApiContentBlockComponentProps } from 'data-source/types.wp'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

interface ComponentOpts<T extends DSResource, A extends ApiComponent> extends PLinkMapperOpts {
  componentItemMapper: (input: A) => T | T[]
}

export function cbComponent<T extends DSResource, A extends ApiComponent>(
  input: ApiContentBlockComponentProps<A>,
  opts: ComponentOpts<T, A>
): DSCBComponent<T> {
  const component = opts.componentItemMapper(input.component)
  const slug = nullableString(input.slug)
  return {
    resource: 'cb-component',
    header: {
      title: input.title,
      pLink: slug ? opts.postLinkBuilder(slug) : null,
    },
    component: Array.isArray(component) ? component : [component],
  }
}
